import MapApp from './app.js';
import { loadLocationData } from './data-loader.js';

const app = new MapApp();

/**
 * Bootstraps the application once the DOM is ready:
 * - loads location data asynchronously
 * - initializes the Leaflet map regardless of data success
 */
if (typeof document !== 'undefined') {
	document.addEventListener('DOMContentLoaded', () => {
		loadLocationData()
			.then(() => {
				app.initialize();
			})
			.catch(() => {
				// Still initialize so the UI can show an error state.
				app.initialize();
			});
	});
}
